import { forwardRef, type ButtonHTMLAttributes } from "react";

/** The round initials button that opens the account menu. */
export const UserAvatarButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { initials: string }
>(({ initials, ...props }, ref) => (
  <button
    ref={ref}
    className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-secondary-foreground text-xs font-bold hover:bg-secondary/90 transition-colors"
    {...props}
  >
    {initials}
  </button>
));
UserAvatarButton.displayName = "UserAvatarButton";
